/** @jsxImportSource @emotion/react */
import { useState } from 'react';

import useTranslate from '@common/hooks/useTranslate';
import { sendGAEvent } from '@common/utlis';
import { container } from '@stories/atoms/Grid';
import ReadMoreButton from '@stories/atoms/ReadMoreButton';

type SEOTextProps = {
  content: string;
};

const translations = {
  'read more': {
    de_DE: '...weiterlesen'
  },
  'read all': {
    de_DE: '...alles lesen'
  }
};

const SEOText: React.FC<SEOTextProps> = ({ content }) => {
  const translate = useTranslate(translations);
  const [linesShown, setLinesShown] = useState<'preview' | 'long' | 'all'>('preview');

  if (typeof content === 'undefined' || content === null) {
    return null;
  }

  return (
    <div
      css={(t) => ({
        ...container,
        ...t.font.small,
        marginBottom: '4rem',
        opacity: '.85',
        overflow: 'hidden',
        position: 'relative',
        maxHeight: { preview: '20rem', long: '50rem', all: 'none' }[linesShown]
      })}
    >
      <div
        className="text"
        dangerouslySetInnerHTML={{
          __html: content.replace(/\\n|\\r/g, '').replace(/\\"/g, '"')
        }}
      />
      {linesShown !== 'all' && (
        <ReadMoreButton
          cssProps={{ position: 'absolute', bottom: 0, right: 'var(--offset)' }}
          label={translate(linesShown === 'preview' ? 'read more' : 'read all')}
          onClick={() => {
            setLinesShown(linesShown === 'preview' ? 'long' : 'all');
            sendGAEvent({
              category: 'read more',
              action: 'click',
              label: `category SEO text - ${linesShown}`
            });
          }}
        />
      )}
    </div>
  );
};

export default SEOText;
export type { SEOTextProps };
